import { Alert, Button, Form, Input, message, Skeleton } from "antd"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { request } from "../../../../utils/config"

/*
  Korxona rekvizitlari — schyot-faktura, nakladnoy va kommersiya taklifi
  shu yerdan oladi. Ilgari blankalarda HAR korxona uchun bitta firmaning
  nomi va bank hisobi chiqardi. Saqlashni faqat korxona administratori
  qila oladi (server tekshiradi).
*/

const FIELDS: { name: string; label: string; placeholder?: string }[] = [
  { name: "titleName", label: "reqTitleName", placeholder: "ZENITH DIGITAL" },
  { name: "legalName", label: "reqLegalName", placeholder: "ООО «...»" },
  { name: "address", label: "reqAddress" },
  { name: "inn", label: "reqInn" },
  { name: "bankName", label: "reqBankName" },
  { name: "bankAccount", label: "reqBankAccount" },
  { name: "mfo", label: "reqMfo" },
  { name: "phone", label: "phone" },
  { name: "email", label: "email" },
  { name: "website", label: "reqWebsite" },
  { name: "contactPerson", label: "reqContactPerson" },
]

const KEY = ["COMPANY_REQUISITES"]

export default function RequisitesTab() {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const queryClient = useQueryClient()

  const { data, isLoading } = useQuery(KEY, async () => {
    const res: any = await request({ url: "CompanyRequisites", method: "GET" })
    return res.data
  })

  useEffect(() => {
    if (data) form.setFieldsValue(data.data || { titleName: data.tenantName, legalName: data.tenantName })
  }, [data, form])

  const { mutate, isLoading: saving } = useMutation(
    (values: any) => request({ url: "CompanyRequisites", method: "PUT", data: values }),
    {
      onSuccess: () => {
        message.success(String(t("reqSaved")))
        queryClient.invalidateQueries(KEY)
      },
      // xato matnini request() o'zi ko'rsatadi
    }
  )

  if (isLoading) return <Skeleton active />

  return (
    <div style={{ maxWidth: 640, margin: "0 auto" }}>
      <Alert type="info" showIcon style={{ marginBottom: 16 }} message={String(t("reqHint"))} />
      <Form form={form} layout="vertical" onFinish={(v) => mutate(v)}>
        {FIELDS.map((f) => (
          <Form.Item key={f.name} name={f.name} label={String(t(f.label))} style={{ marginBottom: 12 }}>
            <Input placeholder={f.placeholder} maxLength={300} />
          </Form.Item>
        ))}
        <Button type="primary" htmlType="submit" loading={saving} block>
          {String(t("save"))}
        </Button>
      </Form>
    </div>
  )
}
